import React from 'react'
import BaseTaxForm from './BaseTaxForm'
import { formTypeList } from '../../constants/form'

const AddNewBaseTax = ({ setOpen }) => {
    return <BaseTaxForm formType={formTypeList.NEW} setOpen={setOpen} />
}

export default AddNewBaseTax
